(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lmf-announcement-ticker"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-ticker-toggle]');
    if (!toggle) return;
    const ticker = toggle.closest('.lmf-ticker');
    const paused = ticker.classList.toggle('is-paused');
    toggle.setAttribute('aria-pressed', String(paused));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lmf-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lmf-hero-model')) {
    customElements.define(
      'lmf-hero-model',
      class extends HTMLElement {
        connectedCallback() {
          this.viewer = this.querySelector('model-viewer');
          if (!this.viewer) return;
          if (this.viewer.loaded) this.start();
          else this.viewer.addEventListener('load', () => this.start(), { once: true });
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          this.observer?.disconnect();
        }

        start() {
          this.classList.add('is-loaded');
          const sway = parseFloat(this.dataset.sway) || 0;
          if (!sway || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          const begin = performance.now();
          const tick = (now) => {
            const t = (now - begin) / 1000;
            const theta = Math.sin((t / 9) * Math.PI * 2) * sway;
            const phi = 82 + Math.sin((t / 12) * Math.PI * 2) * 3;
            this.viewer.cameraOrbit = `${theta.toFixed(2)}deg ${phi.toFixed(2)}deg auto`;
            this.frame = requestAnimationFrame(tick);
          };
          this.observer = new IntersectionObserver(([entry]) => {
            cancelAnimationFrame(this.frame);
            if (entry.isIntersecting) this.frame = requestAnimationFrame(tick);
          });
          this.observer.observe(this);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lmf-limited-drop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lmf-count-up')) {
    customElements.define(
      'lmf-count-up',
      class extends HTMLElement {
        connectedCallback() {
          this.target = parseInt(this.dataset.target, 10);
          if (!(this.target > 0) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          this.textContent = '0';
          this.observer = new IntersectionObserver(
            ([entry]) => {
              if (entry.intersectionRatio >= 0.5) {
                if (!this.frame && this.textContent === '0') this.run();
              } else if (!entry.isIntersecting) {
                this.reset();
              }
            },
            { threshold: [0, 0.5] }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.reset();
        }

        reset() {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = null;
          this.textContent = '0';
        }

        run() {
          const duration = 1600;
          const start = performance.now();
          const step = (now) => {
            const progress = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            this.textContent = String(Math.round(eased * this.target));
            this.frame = progress < 1 ? requestAnimationFrame(step) : null;
          };
          this.frame = requestAnimationFrame(step);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
